/*
 * Aléo Studio cart drawer — Bag / Selections tabs.
 *
 * The Bag tab is entirely the theme's real <cart-drawer>/<cart-form>
 * machinery (assets/cart-drawer.js, CartForm in assets/main.js) — opening,
 * add/remove/quantity, AJAX section refresh, and checkout are all
 * untouched. This file only adds:
 *   - tab switching (Bag / Selections) via a data-aleo-active-tab
 *     attribute on <cart-drawer>, styled in assets/aleo-custom-sections.css
 *   - the Selections tab panel itself, client-rendered from localStorage
 *     since that data doesn't exist server-side
 *   - "Add to Bag" from the Selections tab: a real POST to
 *     theme.routes.cartAdd, mirroring ProductForm's own handleSubmit in
 *     assets/main.js so the header count and drawer refresh exactly as a
 *     normal add-to-cart would
 *
 * "Move to Selections" (was "Save for Later") is handled globally by
 * assets/aleo-selections.js instead of here, since the same button now
 * also renders on the full Bag page (sections/aleo-cart.liquid), not
 * just this drawer.
 */
(function () {
  function optionLinesHtml(options) {
    if (!options || !options.length) return '';
    // A single-variant product's only "option" is Shopify's own auto-
    // created Title/Default Title pair — never real, merchant-facing
    // data (see the other "Default Title" guards sitewide); skip it
    // rather than print "Title: Default Title" in the drawer.
    return options
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) {
        return '<div class="aleo-cart-item__variant">' + o.name + ': ' + o.value + '</div>';
      }).join('');
  }

  // resolveEntry (plain handle or rich object -> a full, currently-
  // accurate { handle, variantId, title, price, image, options, qty,
  // available }) now lives on window.AleoSelections (assets/aleo-
  // selections.js), shared with the main Selections grid page rather
  // than kept as a second, separately-maintained copy here.
  function resolveEntry(entry) {
    return window.AleoSelections.resolveEntry(entry);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('.js-cart-drawer.aleo-bag-drawer');
    if (!drawer) return;

    var tabBag = document.getElementById('CartDrawerModal-Title');
    var tabSelections = document.getElementById('aleoDrawerTabSelections');
    var panelSelectionsBody = document.getElementById('aleoDrawerSelectionsBody');
    var panelSelectionsFoot = document.getElementById('aleoDrawerSelectionsFoot');
    var selectionsUrl = drawer.dataset.selectionsUrl || '/';

    var cartLabel = tabBag.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    function renderTabBagLabel() {
      fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
        tabBag.textContent = cartLabel + (cart.item_count > 0 ? ' (' + cart.item_count + ')' : '');
      });
    }

    var selectionsPanel = drawer.querySelector('[data-aleo-panel="selections"]');

    function setActiveTab(tab) {
      drawer.dataset.aleoActiveTab = tab;
      drawer.querySelectorAll('[data-aleo-tab]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.aleoTab === tab);
      });
      // The panel starts with the native `hidden` attribute as its safe
      // pre-JS default (see sections/cart-drawer.liquid) — [hidden] beats
      // the data-aleo-active-tab CSS rule outright, so it has to come off
      // here, not just be toggled via the data attribute.
      selectionsPanel.hidden = tab !== 'selections';
      if (tab === 'selections') renderSelectionsPanel();
    }

    function renderTabSelectionsLabel() {
      var count = window.AleoSelections ? window.AleoSelections.read().length : 0;
      tabSelections.textContent = 'Selections' + (count > 0 ? ' (' + count + ')' : '');
    }

    function renderSelectionsPanel() {
      var list = window.AleoSelections ? window.AleoSelections.read() : [];
      renderTabSelectionsLabel();

      if (!list.length) {
        panelSelectionsBody.innerHTML = '<p class="aleo-bag-drawer__empty">As you browse, save items to build your selections.</p>';
        panelSelectionsFoot.innerHTML = '';
        return;
      }

      Promise.all(list.map(resolveEntry)).then(function (resolved) {
        // Drop any entry that failed to resolve (its product no longer
        // exists) and write the cleaned list back, same repair
        // assets/aleo-selections.js's own grid render does -- this
        // panel can run without that page ever having loaded, so it
        // can't rely on that page to be the one that cleans storage up.
        var stillValid = [];
        var entries = [];
        resolved.forEach(function (e, i) {
          if (e) { stillValid.push(list[i]); entries.push(e); }
        });
        if (stillValid.length !== list.length && window.AleoSelections) {
          window.AleoSelections.write(stillValid);
        }

        if (!entries.length) {
          panelSelectionsBody.innerHTML = '<p class="aleo-bag-drawer__empty">As you browse, save items to build your selections.</p>';
          panelSelectionsFoot.innerHTML = '';
          return;
        }

        panelSelectionsBody.innerHTML = entries.map(function (e) {
          return (
            '<div class="cart-item aleo-cart-item">' +
              '<div class="cart-item__column cart-item__image"><img src="' + e.image + '" alt="" width="140" loading="lazy"></div>' +
              '<div class="cart-item__not-image">' +
                '<div class="cart-item__column cart-item__description">' +
                  '<div class="cart-item__title">' + e.title + '</div>' +
                  '<div class="small-text">' + optionLinesHtml(e.options) + '</div>' +
                '</div>' +
                '<div class="cart-item__column cart-item__price"><span class="theme-money cart-item__selling-price">' + e.price + '</span></div>' +
                '<div class="cart-item__column cart-item__quantity">' +
                  '<div class="aleo-cart-item__qty">Qty: ' + e.qty + '</div>' +
                  '<div class="aleo-cart-item__actions">' +
                    '<button type="button" class="aleo-cart-item__add-to-bag underline" data-aleo-add-to-bag data-variant-id="' + e.variantId + '" data-qty="' + e.qty + '" data-handle="' + e.handle + '">Add to Bag</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');

        panelSelectionsFoot.innerHTML = '<a href="' + selectionsUrl + '" class="aleo-bag-drawer__btn aleo-bag-drawer__btn--primary">View Selections</a>';
      });
    }

    function addToBagFromSelections(btn) {
      var variantId = btn.dataset.variantId;
      var qty = btn.dataset.qty || '1';
      var handle = btn.dataset.handle;

      btn.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', qty);

      var sectionsToUpdate = ['page-header', 'cart-drawer'].map(function (sel) { return document.querySelector(sel); }).filter(Boolean);
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sectionsToUpdate.map(function (el) { return el.dataset.sectionId; }).join(','));

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          sectionsToUpdate.forEach(function (el) {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          });
          window.AleoSelections.removeSelection(handle, Number(variantId));
          setActiveTab('bag');
          renderTabBagLabel();
          renderTabSelectionsLabel();
        })
        .catch(function (error) {
          console.log(error); // eslint-disable-line
          btn.disabled = false;
        });
    }

    drawer.addEventListener('click', function (evt) {
      var tabBtn = evt.target.closest('[data-aleo-tab]');
      if (tabBtn) { setActiveTab(tabBtn.dataset.aleoTab); return; }

      // "Move to Selections" itself is handled globally now (assets/
      // aleo-selections.js), since it also has to work on the full Bag
      // page, not just inside this drawer.

      var addToBagBtn = evt.target.closest('[data-aleo-add-to-bag]');
      if (addToBagBtn) { addToBagFromSelections(addToBagBtn); }
    });

    // Cart changes elsewhere (qty steppers, remove on the full /cart page,
    // another add-to-cart) should keep both tab labels current even when
    // a given tab isn't the active one right now.
    document.addEventListener('on:cart:change', renderTabBagLabel);
    document.addEventListener('on:cart:add', renderTabBagLabel);
    document.addEventListener('on:cart:change', renderTabSelectionsLabel);
    document.addEventListener('on:cart:add', renderTabSelectionsLabel);

    renderTabSelectionsLabel();
  });
})();
